import classNames from "classnames";
import { motion } from "framer-motion";
import { FunctionComponent } from "react";
import "./style.scss";

interface Props {
  onClick: () => void;
  onFullPage?: boolean;
}

const AnimatedOverlay: FunctionComponent<Props> = ({ onClick, onFullPage = false }) => {
  return (
    <motion.div
      animate={{ opacity: 1 }}
      className={classNames("AnimatedOverlay", {
        "AnimatedOverlay--fullPage": onFullPage,
      })}
      exit={{
        opacity: 0,
      }}
      initial={{ opacity: 0 }}
      onClick={onClick}
    />
  );
};

export default AnimatedOverlay;
